import React from 'react';
import {Button, Table} from "react-bootstrap";

const PartnerDomainsTable = ({ domains, onRemove, sort, onNoteEdit }) => {
    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
            <tr>
                <th onClick={() => sort('partner_name')}>Partner Name</th>
                <th onClick={() => sort('country')}>Country</th>
                <th>IP</th>
                <th onClick={() => sort('domain')}>Domain</th>
                <th onClick={() => sort('virusTotal')}>VirusTotal</th>
                <th onClick={() => sort('sucuri')}>Sucuri</th>
                <th onClick={() => sort('avast')}>Avast</th>
                <th onClick={() => sort('avastFlagged')}>AvastFlagged</th>
                <th onClick={() => sort('flagged')}>Flagged</th>
                <th onClick={() => sort('flaggedAt')}>FlaggedAt</th>
                <th onClick={() => sort('note')}>Note</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {
                domains.map((domain, index) => {
                    return (<tr key={index}>
                        <th>{domain.partner_name}</th>
                        <th>{domain.country}</th>
                        <th>{domain.ip}</th>
                        <th>{domain.domain}</th>
                        <th>{domain.virusTotal}</th>
                        <th>{domain.sucuri}</th>
                        <th>{domain.avast}</th>
                        <th>{domain.avastFlagged}</th>
                        <th>{domain.flagged}</th>
                        <th>{domain.flaggedAt}</th>
                        <th style={{ width: '10%'}}>{domain.note}</th>
                        <th style={{ width: '1%', whiteSpace: 'nowrap' }}>
                            <Button onClick={() => onNoteEdit(domain)} style={{ marginRight: '5px' }} bsStyle={'primary'}>Edit Note</Button>
                            <Button onClick={() => onRemove(domain.id)} bsStyle={'danger'}>Remove</Button>
                        </th>
                    </tr>)
                })
            }
            </tbody>
        </Table>
    );
};

export default PartnerDomainsTable;


// WEBPACK FOOTER //
// ./src/scenes/PartnerDomains/components/PartnerDomainsTable/PartnerDomainsTable.js